import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { ISecureInformationRequest } from './types';

function useSecureInformationRequest(secureInformationRequestId: string) {
  const {
    data,
    error,
    mutate,
  }: {
    data?: ISecureInformationRequest;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    secureInformationRequestId
      ? `secureInformationRequest/${secureInformationRequestId}`
      : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}

export { useSecureInformationRequest };
